import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { Button, Skeleton } from '@workspace/shadcn';

import { useCourses } from '../../lib/api.ts';
import { CourseCard } from '../components/course-card.tsx';
import { Section } from '../components/section.tsx';
import { BlurFade } from '../components/effects/blur-fade.tsx';

export function FeaturedCourses() {
  const { data, isLoading, isError } = useCourses();

  const courses = (data?.records ?? [])
    .filter((course) => !course.comingSoon)
    .slice(0, 3);

  return (
    <Section className="z-20">
      <h2 className="text-4xl font-bold tracking-tighter">Featured Courses</h2>
      <p className="text-muted-foreground my-4 max-w-[640px]">
        Our courses are designed to help you learn and grow as a healthcare
        professional.
      </p>

      {isError ? (
        <p className="text-muted-foreground mt-6">
          Our courses are taking a moment to load. Please refresh the page.
        </p>
      ) : (
        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {isLoading
            ? Array.from({ length: 3 }, (_, index) => (
                <Skeleton key={index} className="h-[420px] rounded-2xl" />
              ))
            : courses.map((course) => (
                <BlurFade key={course.slug} delay={0.25} inView>
                  <CourseCard course={course} />
                </BlurFade>
              ))}
        </div>
      )}

      <div className="mt-12 flex items-center justify-center">
        <Link to="/courses">
          <Button
            variant="outline"
            className="group flex h-12 items-center gap-1 px-8 text-base"
          >
            View All Courses
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Button>
        </Link>
      </div>
    </Section>
  );
}
